module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/voucher'
      }
    }
  }, [_vm._v("Kode Voucer")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('channel') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E Commerce Channel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.channel_id),
      expression: "form.channel_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "channel_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listChannel), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('name') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Product")]), _vm._v(" "), _vm._l((_vm.form.products), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "row",
      staticStyle: {
        "padding-bottom": "5px"
      }
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('model-select', {
      attrs: {
        "options": _vm.productList,
        "placeholder": "Pilih Produk"
      },
      model: {
        value: (_vm.form.products[i].product_id),
        callback: function($$v) {
          _vm.$set(_vm.form.products[i], "product_id", $$v)
        },
        expression: "form.products[i].product_id"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.products[i].amount),
        expression: "form.products[i].amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (_vm.form.products[i].amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.products[i], "amount", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(_vm.form.products.length >= 1 && i == _vm.form.products.length - 1) ? _c('button', {
      staticClass: "btn btn-success btn-md m-1",
      attrs: {
        "type": "buttom"
      },
      on: {
        "click": function($event) {
          return _vm.pushProduct(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })]) : _vm._e(), _vm._v(" "), (_vm.form.products.length > 1 && i != _vm.form.products.length - 1) ? _c('button', {
      staticClass: "btn btn-danger btn-md m-1",
      attrs: {
        "type": "buttom"
      },
      on: {
        "click": function($event) {
          return _vm.form.products.splice(i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Buat Voucher")])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Voucher")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bf2963c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/voucher/Form.vue
// module id = 1335
// module chunks = 0